import RestService from '../services/rest';

async function getListProjectsDirectory(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/projectsDirectory/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function searchPaginatedContactList(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/projectsDirectory/contactList?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getCsvProjectsDirectory() {
  const response = await RestService.getAuthenticated('panel/projectsDirectory/csv/model', { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'projects-directory-model.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getContactReportCsv() {
  const response = await RestService.getAuthenticated('panel/projectsDirectory/contactReport/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'contact-list-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvProjectsDirectory(file) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated('panel/projectsDirectory/csv/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function uploadProjectsDirectory(projectsDirectoryParameter) {
  return RestService.putAuthenticated('panel/projectsDirectory/update', projectsDirectoryParameter);
}

async function deleteProjectsDirectory(projectsDirectoryId) {
  return RestService.deleteAuthenticated('panel/projectsDirectory/delete', { projectsDirectoryId });
}

export default {
  searchPaginatedContactList,
  getListProjectsDirectory,
  getCsvProjectsDirectory,
  getContactReportCsv,
  uploadCsvProjectsDirectory,
  uploadProjectsDirectory,
  deleteProjectsDirectory,
};
